export default __webpack_public_path__ + "static/media/G0120.34I-29378_-17035_0.1666197900000.01a65570.jpg";